import React, { Component } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import axios from "axios"
import InstagramLogo from "../assets/svg/instagram.svg"

class Instagram extends Component {
  constructor(props) {
    super(props)

    this.state = {
      images: [
        {
          node: {
            thumbnail_src: "https://via.placeholder.com/335",
            accessibility_caption: "Instagram 1",
          },
        },
        {
          node: {
            thumbnail_src: "https://via.placeholder.com/335",
            accessibility_caption: "Instagram 2",
          },
        },
        {
          node: {
            thumbnail_src: "https://via.placeholder.com/335",
            accessibility_caption: "Instagram 3",
          },
        },
        {
          node: {
            thumbnail_src: "https://via.placeholder.com/335",
            accessibility_caption: "Instagram 4",
          },
        },
        {
          node: {
            thumbnail_src: "https://via.placeholder.com/335",
            accessibility_caption: "Instagram 5",
          },
        },
        {
          node: {
            thumbnail_src: "https://via.placeholder.com/335",
            accessibility_caption: "Instagram 6",
          },
        },
      ],
    }
  }

  componentDidMount() {
    this.props.social.map((link) => {
      if (link.url.includes("instagram")) {
        const response = axios.get(link.url + "channel/?__a=1").then((data) => {
          if (
            data.data.graphql.user.edge_owner_to_timeline_media.edges.length
          ) {
            this.setState({
              images: data.data.graphql.user.edge_owner_to_timeline_media.edges,
            })
          }
        })
      }
    })
  }

  render() {
    const { images } = this.state

    return (
      <section className="instagram">
        <div className="icon show-mobile">
          <img src={InstagramLogo} alt="Follow us" />
        </div>
        <h3 className="show-desktop">Follow us</h3>
        <div className="images-wrap">
          <Swiper
            slidesPerView={3}
            spaceBetween={10}
            navigation
            breakpoints={{ 980: { slidesPerView: 6, spaceBetween: 0 } }}
          >
            {images &&
              images.length > 0 &&
              images.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <div key={index} className="image-container">
                      <img
                        src={item.node.thumbnail_src}
                        alt={item.node.accessibility_caption}
                      />
                    </div>
                  </SwiperSlide>
                )
              })}
          </Swiper>
        </div>
      </section>
    )
  }
}

export default Instagram
